import cn from 'clsx'
import {
    DetailIcon,
    NavigationMenuItemPlaceholder,
    NavigationMenuListPlaceholder,
    NavigationMenuPlaceholder,
    NavigationMenuTriggerPlaceholder,
} from '@ds/components'
import { NavLink } from './NavLink'
import type { TNavigationProps } from './Navigation.types'
import styles from './Navigation.module.css'

export const NavigationPlaceholder = ({ navEntries, label }: TNavigationProps) => {
    const hasCollapsedEntries = navEntries.some(entry => entry.collapsible)

    return (
        <NavigationMenuPlaceholder className={styles.nav} role="navigation" aria-label={label}>
            <NavigationMenuListPlaceholder className={styles.navList}>
                {navEntries.map(entry =>
                    entry.kind === 'dropdown' ? (
                        <NavigationMenuItemPlaceholder
                            key={entry.label}
                            className={cn(
                                styles.navItem,
                                entry.collapsible && styles.collapsible,
                                entry.panel === 'grid' && styles.fullBleedItem,
                            )}
                        >
                            <span
                                className={styles.triggerWrap}
                                data-active={entry.isActive || undefined}
                            >
                                <NavigationMenuTriggerPlaceholder className={styles.navTrigger}>
                                    {entry.label}
                                </NavigationMenuTriggerPlaceholder>
                            </span>
                        </NavigationMenuItemPlaceholder>
                    ) : (
                        <NavigationMenuItemPlaceholder
                            key={entry.label}
                            className={cn(styles.navItem, entry.collapsible && styles.collapsible)}
                            data-active={entry.isActive || undefined}
                        >
                            <NavLink entry={entry} />
                        </NavigationMenuItemPlaceholder>
                    ),
                )}

                {hasCollapsedEntries ? (
                    <NavigationMenuItemPlaceholder className={styles.moreItem}>
                        <NavigationMenuTriggerPlaceholder
                            className={styles.moreTrigger}
                            showIcon={false}
                        >
                            <DetailIcon className={styles.moreIcon} />
                        </NavigationMenuTriggerPlaceholder>
                    </NavigationMenuItemPlaceholder>
                ) : null}
            </NavigationMenuListPlaceholder>
        </NavigationMenuPlaceholder>
    )
}
